import React from "react";
import {
  RecipientPotentiallyUnknownOrg,
  RecipientUser,
} from "../../../../../domain/RecipientsViewModel";
import {
  Checkbox,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import { OrgAction } from "./reducer";

const useStyles = makeStyles((theme) => ({
  userList: {},
  userListItem: {
    paddingLeft: theme.spacing(8),
  },
  userListItemIcon: {
    padding: 0,
  },
  checkbox: {
    padding: 0,
    margin: 0,
  },
}));

type ManageRecipientUserProps = {
  org: RecipientPotentiallyUnknownOrg;
  user: RecipientUser;
  dispatch: React.Dispatch<OrgAction>;
};

export const ManageRecipientUser: React.FC<ManageRecipientUserProps> = ({
  org,
  user,
  dispatch,
}) => {
  const classes = useStyles();

  const handleClick = () => {
    const nextValue = !user.isToDelete;
    dispatch({
      type: "FLAG_USER",
      payload: { orgId: org.id, userId: user.id, isToDelete: nextValue },
    });
  };
  return (
    <ListItem
      button
      classes={{ root: classes.userListItem }}
      dense
      onClick={handleClick}
    >
      <ListItemIcon className={classes.userListItemIcon}>
        <Checkbox
          className={classes.checkbox}
          edge="start"
          checked={!!user.isToDelete}
          onChange={handleClick}
        />
      </ListItemIcon>
      <ListItemText primary={user.upn} style={{ margin: 0 }} />
    </ListItem>
  );
};
